import Image from "next/image";

const Footer = ({ quickLinks, contactUs, bottomLinks, copyrightText }) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU === "true";
  const filter = isAU ? (q) => q.isAU : (q) => q.isNZ;

  const filteredLinks = {
    quickLinks: quickLinks.filter(filter),
    contactUs: contactUs.filter(filter),
    bottomLinks: bottomLinks.filter(filter),
  };

  const SocialLink = ({ href, src, alt }) => (
    <li className='list-inline-item'>
      <a href={href} target='_blank' rel='noopener noreferrer' aria-label={alt}>
        <Image src={src} width={32} height={32} alt={alt} loading='lazy' />
      </a>
    </li>
  );

  const FooterList = ({ title, items }) => (
    <div className='col-sm-2'>
      <p className='footer-subheader'>{title}</p>
      {items.length > 0 && (
        <ul className='list-unstyled footer-links mt-2'>
          {items.map((item, idx) => (
            <li key={idx}>
              <a href={item.url}>{item.title}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <footer className='page-footer bg-secondary text-white'>
      <div className='container pt-lg-5 pt-3'>
        {/* Logo Section */}
        <div className='footer-logo-section mb-1 mb-lg-5 d-flex justify-content-between'>
          <Image
            src='/img/footer-logo.svg'
            width={100}
            height={45}
            alt='Ryco Logo'
            loading='lazy'
          />
          <Image
            src='/img/supercars.svg'
            width={80}
            height={80}
            alt='Supercars Logo'
            loading='lazy'
          />
        </div>

        {/* Main Content */}
        <div className='row'>
          <div className='col-sm-4'>
            <p className='footer-subheader' style={{ maxWidth: "373px" }}>
              Our design philosophy aims to meet or exceed original equipment.
              Ryco Filters deliver genuine performance based on efficiency,
              life, and flow.
            </p>
          </div>
          <div className='col-sm-4'>
            <p className='footer-subheader'>Ryco Guarantee</p>
            <dl className='footer-links mt-2'>
              <dt>Efficiency</dt>
              <dd>The percentage of dirt that a filter removes</dd>
              <dt>Life</dt>
              <dd>How long a filter lasts before clogging up</dd>
              <dt>Flow</dt>
              <dd>How easily air, oil, or fuel flows through the filter</dd>
            </dl>
          </div>
          <FooterList title='Quick Links' items={filteredLinks.quickLinks} />
          <FooterList title='Contact Us' items={filteredLinks.contactUs} />
        </div>

        {/* Social Links and Bottom Links */}
        <div className='row mt-lg-4 mt-0'>
          <div className='col-sm-6'>
            <ul className='list-inline social-icons-list'>
              <SocialLink
                href='https://www.instagram.com/rycofilters/'
                src='/icons/instagram.svg'
                alt='Instagram'
              />
              <SocialLink
                href='https://www.facebook.com/rycofilters/'
                src='/icons/facebook.svg'
                alt='Facebook'
              />
              <SocialLink
                href='https://www.linkedin.com/company/ryco-group/'
                src='/icons/linkedin.svg'
                alt='LinkedIn'
              />
              <SocialLink
                href='https://www.youtube.com/channel/UC8HQNM_vRLCW9r59KsX57Mg?view_as=subscriber'
                src='/icons/youtube.svg'
                alt='YouTube'
              />
              <SocialLink
                href='https://www.tiktok.com/@rycofilters'
                src='/icons/tiktok.svg'
                alt='TikTok'
              />
            </ul>
          </div>
          <div className='col-sm-6'>
            <ul className='list-inline text-lg-end footer-short-nav'>
              {filteredLinks.bottomLinks.map((item, idx) => (
                <li key={idx} className='list-inline-item'>
                  <a href={item.url}>{item.title}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer Section */}
      <div className='container'>
        <p className='footer-divider mt-3 mb-0'></p>
        <div className='d-flex align-items-center justify-content-between footer-bottom-line'>
          <div className='copyright-text'>
            {copyrightText}
            
          </div>
          <Image
            src='/img/tagline.svg'
            width={86}
            height={60}
            alt='BE RYCO READY'
            loading='lazy'
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
